import { Component, DestroyRef, effect, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { filter, take } from 'rxjs';
import { HlmDialogService } from '@spartan-ng/helm/dialog';
import {
  PostAuthNavigation,
  BlockUiService,
  FileService,
  AuthStoreService,
  UserStrategy,
} from 'shared';
import { UnsupportedFileTypeDialogComponent, ToastComponent } from 'ui';

@Component({
  selector: 'ocp-root',
  imports: [RouterOutlet, ToastComponent],
  providers: [PostAuthNavigation, FileService],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private readonly blockUiService = inject(BlockUiService);
  private readonly userFacade = inject(UserStrategy);
  private readonly postAuthNavigation = inject(PostAuthNavigation);
  private readonly fileService = inject(FileService);
  private readonly dialogService = inject(HlmDialogService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly authStore = inject(AuthStoreService);

  protected readonly isBlocked = this.blockUiService.isBlocked;

  constructor() {
    this.postAuthNavigation.performNavigation();

    // Always defer until a token is present: covers OIDC login, embedded host-token,
    // and OIDC redirect callbacks where the callback URL has no ?embedded=1 yet.
    this.authStore.accessToken$
      .pipe(
        filter(token => !!token),
        take(1),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => this.userFacade.userSignalrService.init());

    // Handle unsupported file type globally
    effect(() => {
      if (this.fileService.unsupportedFile()) {
        const ref = this.dialogService.open(
          UnsupportedFileTypeDialogComponent,
          this.fileService.unsupportedFileTypeDialogConfig
        );
        this.fileService.handleUnsupportedFileDialogClose(ref, this.destroyRef);
      }
    });
  }
}
